webpackJsonp([89399205538831],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	    factory(exports, module);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, mod);
	    global.fetchJsonp = mod.exports;
	  }
	})(this, function (exports, module) {
	  'use strict';
	
	  var defaultOptions = {
	    timeout: 5000,
	    jsonpCallback: 'callback',
	    jsonpCallbackFunction: null
	  };
	
	  function generateCallbackFunction() {
	    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	  }
	
	  function clearFunction(functionName) {
	    // IE8 throws an exception when you try to delete a property on window
	    // http://stackoverflow.com/a/1824228/751089
	    try {
	      delete window[functionName];
	    } catch (e) {
	      window[functionName] = undefined;
	    }
	  }
	
	  function removeScript(scriptId) {
	    var script = document.getElementById(scriptId);
	    if (script) {
	      document.getElementsByTagName('head')[0].removeChild(script);
	    }
	  }
	
	  function fetchJsonp(_url) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // to avoid param reassign
	    var url = _url;
	    var timeout = options.timeout || defaultOptions.timeout;
	    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
	
	    var timeoutId = undefined;
	
	    return new Promise(function (resolve, reject) {
	      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	      var scriptId = jsonpCallback + '_' + callbackFunction;
	
	      window[callbackFunction] = function (response) {
	        resolve({
	          ok: true,
	          // keep consistent with fetch API
	          json: function json() {
	            return Promise.resolve(response);
	          }
	        });
	
	        if (timeoutId) clearTimeout(timeoutId);
	
	        removeScript(scriptId);
	
	        clearFunction(callbackFunction);
	      };
	
	      // Check if the user set their own params, and if not add a ? to start a list of params
	      url += url.indexOf('?') === -1 ? '?' : '&';
	
	      var jsonpScript = document.createElement('script');
	      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
	      if (options.charset) {
	        jsonpScript.setAttribute('charset', options.charset);
	      }
	      jsonpScript.id = scriptId;
	      document.getElementsByTagName('head')[0].appendChild(jsonpScript);
	
	      timeoutId = setTimeout(function () {
	        reject(new Error('JSONP request to ' + _url + ' timed out'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	      }, timeout);
	
	      // Caught if got 404/500
	      jsonpScript.onerror = function () {
	        reject(new Error('JSONP request to ' + _url + ' failed'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	        if (timeoutId) clearTimeout(timeoutId);
	      };
	    });
	  }
	
	  // export as global function
	  /*
	  let local;
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	  local.fetchJsonp = fetchJsonp;
	  */
	
	  module.exports = fetchJsonp;
	});

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(257));
		else if(typeof define === 'function' && define.amd)
			define("GetSheetDone", ["fetch-jsonp"], factory);
		else if(typeof exports === 'object')
			exports["GetSheetDone"] = factory(require("fetch-jsonp"));
		else
			root["GetSheetDone"] = factory(root["fetchJsonp"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildUrl = buildUrl;
	exports.parseRawCells = parseRawCells;
	exports.parseLabeledCols = parseLabeledCols;
	exports.parseLabeledRowsCols = parseLabeledRowsCols;
	exports.raw = raw;
	exports.labeledCols = labeledCols;
	exports.labeledColsRows = labeledColsRows;
	
	var _fetchJsonp = __webpack_require__(1);
	
	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function buildUrl(id, sheetNum, mode) {
	  return 'https://spreadsheets.google.com/feeds/' + mode + '/' + id + '/' + sheetNum + '/public/values?alt=json-in-script';
	}
	
	// Generic fetch and parse function
	function fetchAndParse(id, sheetNum, type, parseEntries) {
	  if (id.length === 0) {
	    return Promise.reject(new Error('empty id'));
	  }
	  var url = buildUrl(id, sheetNum, type);
	  return new Promise(function (resolve, reject) {
	    (0, _fetchJsonp2.default)(url).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      var data = parseEntries(json.feed.entry);
	      var res = {
	        title: json.feed.title.$t,
	        updated: json.feed.updated.$t,
	        data: data
	      };
	      resolve(res);
	    }).catch(function (ex) {
	      reject(ex);
	    });
	  });
	}
	
	function parseRawCells(entries) {
	  var data = [];
	  entries.forEach(function (cell) {
	    var row = parseInt(cell.gs$cell.row, 10) - 1;
	    var col = parseInt(cell.gs$cell.col, 10) - 1;
	    var content = cell.gs$cell.$t;
	    if (data[row] === undefined) {
	      data[row] = [];
	    }
	    data[row][col] = content;
	  });
	  return data;
	}
	
	/**
	 * Use for table with labels only for columns
	 */
	function parseEntry(entry) {
	  var res = {};
	  Object.keys(entry).forEach(function (key) {
	    if (key.indexOf('gsx$') === 0) {
	      var label = key.substr(4);
	      res[label] = entry[key].$t;
	    }
	  });
	  return res;
	}
	
	/**
	 * Parser for table where just the columns are labeled
	 * @return array of objects where the labels are keys
	 */
	function parseLabeledCols(entries) {
	  return entries.map(function (entry) {
	    return parseEntry(entry);
	  });
	}
	
	/**
	 * Use for table with labels for rows AND columns
	 * Example input: "bar: 123, baz: 122, bab: 234"
	 */
	function parseLabeledRow(row) {
	  var cols = row.split(', ');
	  var res = cols.reduce(function (acc, col) {
	    var pair = col.split(': ');
	    acc[pair[0]] = pair[1];
	    return acc;
	  }, {});
	  return res;
	}
	
	/**
	 * Parser for table where both rows and columns are labeled
	 * @return object where keys are row labels and values are objects where keys are the column labels
	 */
	function parseLabeledRowsCols(entries) {
	  var res = {};
	  entries.forEach(function (entry) {
	    res[entry.title.$t] = parseLabeledRow(entry.content.$t);
	  });
	  return res;
	}
	
	// fetch as raw arrays
	function raw(id) {
	  var sheetNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return fetchAndParse(id, sheetNum, 'cells', parseRawCells);
	}
	
	// fetch as array of labeled columns
	function labeledCols(id) {
	  var sheetNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return fetchAndParse(id, sheetNum, 'list', parseLabeledCols);
	}
	
	// fetch as labeled map of labeled columns
	function labeledColsRows(id) {
	  var sheetNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return fetchAndParse(id, sheetNum, 'list', parseLabeledRowsCols);
	}
	
	exports.default = {
	  raw: raw,
	  labeledCols: labeledCols,
	  labeledColsRows: labeledColsRows
	};
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ })
	/******/ ])["default"];
	});
	//# sourceMappingURL=GetSheetDone.js.map

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(154);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(51);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _spinners = __webpack_require__(952);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies
	
	
	if (!({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"}).REACT_SPINKIT_NO_STYLES) {
	  /* eslint-disable global-require */
	  __webpack_require__(233);
	  __webpack_require__(234);
	  __webpack_require__(241);
	  __webpack_require__(239);
	  __webpack_require__(235);
	  __webpack_require__(236);
	  __webpack_require__(237);
	  __webpack_require__(238);
	  __webpack_require__(240);
	  __webpack_require__(242);
	  __webpack_require__(243);
	  __webpack_require__(244);
	  __webpack_require__(245);
	  __webpack_require__(246);
	  __webpack_require__(247);
	  /* eslint-enable global-require */
	}
	
	var noFadeInWarning = "Deprecation Warning (react-spinkit): noFadeIn prop should be replaced with fadeIn='none'";
	
	var Spinner = function (_React$Component) {
	  _inherits(Spinner, _React$Component);
	
	  function Spinner(props) {
	    _classCallCheck(this, Spinner);
	
	    if (props.noFadeIn) {
	      console.warn(noFadeInWarning); // eslint-disable-line no-console
	    }
	
	    var _this = _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, props));
	
	    _this.displayName = 'SpinKit';
	    return _this;
	  }
	
	  _createClass(Spinner, [{
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      var spinnerInfo = _spinners.allSpinners[this.props.name] || _spinners.allSpinners['three-bounce'];
	      var classes = (0, _classnames2.default)((_cx = {
	        'sk-fade-in': this.props.fadeIn === 'full' && !this.props.noFadeIn,
	        'sk-fade-in-half-second': this.props.fadeIn === 'half' && !this.props.noFadeIn,
	        'sk-fade-in-quarter-second': this.props.fadeIn === 'quarter' && !this.props.noFadeIn,
	        'sk-spinner': !this.props.overrideSpinnerClassName
	      }, _defineProperty(_cx, this.props.overrideSpinnerClassName, !!this.props.overrideSpinnerClassName), _defineProperty(_cx, this.props.className, !!this.props.className), _defineProperty(_cx, spinnerInfo.className || this.props.name, true), _cx));
	
	      var props = (0, _objectAssign2.default)({}, this.props);
	      delete props.name;
	      delete props.fadeIn;
	      delete props.noFadeIn;
	      delete props.overrideSpinnerClassName;
	      delete props.className;
	
	      if (this.props.color) {
	        props.style = props.style ? _extends({}, props.style, { color: this.props.color }) : { color: this.props.color };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: classes }),
	        [].concat(_toConsumableArray(Array(spinnerInfo.divCount))).map(function (_, idx) {
	          return _react2.default.createElement('div', { key: idx });
	        })
	      );
	    }
	  }]);
	
	  return Spinner;
	}(_react2.default.Component);
	
	Spinner.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  noFadeIn: _propTypes2.default.bool,
	  fadeIn: _propTypes2.default.oneOf(['full', 'half', 'quarter', 'none']),
	  overrideSpinnerClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  color: _propTypes2.default.string
	};
	
	Spinner.defaultProps = {
	  name: 'three-bounce',
	  noFadeIn: false,
	  fadeIn: 'full',
	  overrideSpinnerClassName: ''
	};
	
	module.exports = Spinner;

/***/ }),

/***/ 952:
/***/ (function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var spinkitSpinners = {
	  circle: { className: 'sk-circle', divCount: 12 },
	  'cube-grid': { className: 'sk-cube-grid', divCount: 9 },
	  wave: { className: 'sk-wave', divCount: 5 },
	  'folding-cube': { className: 'sk-folding-cube', divCount: 4 },
	  'three-bounce': { className: 'sk-three-bounce', divCount: 3 },
	  'double-bounce': { className: 'sk-double-bounce', divCount: 2 },
	  'wandering-cubes': { className: 'sk-wandering-cubes', divCount: 2 },
	  'chasing-dots': { className: 'sk-chasing-dots', divCount: 2 },
	  'rotating-plane': { className: 'sk-rotating-plane', divCount: 1 },
	  pulse: { className: 'sk-pulse', divCount: 1 },
	  wordpress: { className: 'sk-wordpress', divCount: 1 }
	};
	
	var loadersCssSpinners = {
	  'ball-grid-beat': { divCount: 9 },
	  'ball-grid-pulse': { divCount: 9 },
	  'line-spin-fade-loader': { divCount: 8 },
	  'ball-spin-fade-loader': { divCount: 8 },
	  'ball-pulse-rise': { divCount: 5 },
	  'line-scale': { divCount: 5 },
	  'line-scale-pulse-out': { divCount: 5 },
	  'line-scale-pulse-out-rapid': { divCount: 5 },
	  pacman: { divCount: 5 },
	  'line-scale-party': { divCount: 4 },
	  'ball-triangle-path': { divCount: 3 },
	  'ball-scale-multiple': { divCount: 3 },
	  'ball-scale-ripple-multiple': { divCount: 3 },
	  'ball-pulse-sync': { divCount: 3 },
	  'ball-beat': { divCount: 3 },
	  'ball-zig-zag': { divCount: 2 },
	  'ball-zig-zag-deflect': { divCount: 2 },
	  'ball-clip-rotate-pulse': { divCount: 2 },
	  'ball-clip-rotate-multiple': { divCount: 2 },
	  'ball-clip-rotate': { divCount: 1 },
	  'ball-scale-ripple': { divCount: 1 },
	  'triangle-skew-spin': { divCount: 1 }
	};
	
	module.exports = {
	  spinkitSpinners: spinkitSpinners,
	  loadersCssSpinners: loadersCssSpinners,
	  allSpinners: _extends({}, spinkitSpinners, loadersCssSpinners)
	};

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(290);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsListing = function NewsListing(props) {
	  return _react2.default.createElement(
	    'section',
	    { className: 'features', id: 'features' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'features-title' },
	            'Features'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'features-list' },
	            props.data.map(function (item, i) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'features-list-item', key: i },
	                item.title
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewsListing;
	module.exports = exports['default'];

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fa = __webpack_require__(14);
	
	__webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuItems = function MenuItems(props) {
	  return _react2.default.createElement(
	    "section",
	    { className: "menu-items", id: "menu-items" },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 text-center" },
	          _react2.default.createElement(
	            "h4",
	            { className: "title fancy" },
	            _react2.default.createElement(
	              "span",
	              { className: "menu-items-title" },
	              props.title
	            )
	          ),
	          _react2.default.createElement(
	            "h5",
	            { style: { marginTop: 30 } },
	            props.description
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        props.data.map(function (item, i) {
	          return _react2.default.createElement(
	            "div",
	            { className: "col-lg-4 col-md-6 col-sm-12 menu-items-list", key: i },
	            _react2.default.createElement(
	              "div",
	              { className: "menu-items-list-item custom-card" },
	              _react2.default.createElement(
	                "div",
	                { className: "menu-items-list-item-title" },
	                item.title,
	                item.vegetarian === 'YES' ? _react2.default.createElement(
	                  "span",
	                  {
	                    style: {
	                      float: "right",
	                      fontSize: 14,
	                      fontWeight: 300,
	                      color: "#0c720c"
	                    }
	                  },
	                  _react2.default.createElement(_fa.FaCutlery, null)
	                ) : ""
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "menu-items-list-item-info" },
	                item.price,
	                " - (",
	                item.calories,
	                " cal.)"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "menu-items-list-item-desc" },
	                item.description
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = MenuItems;
	module.exports = exports["default"];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _features = __webpack_require__(131);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _breadcrumb = __webpack_require__(15);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _menuItems = __webpack_require__(138);
	
	var _menuItems2 = _interopRequireDefault(_menuItems);
	
	var _nav = __webpack_require__(29);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _getSheetDone = __webpack_require__(276);
	
	var _getSheetDone2 = _interopRequireDefault(_getSheetDone);
	
	var _fa = __webpack_require__(14);
	
	var _reactSpinkit = __webpack_require__(951);
	
	var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global graphql */
	
	var MenuPage = function (_React$Component) {
	  _inherits(MenuPage, _React$Component);
	
	  function MenuPage() {
	    _classCallCheck(this, MenuPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      entrees: [],
	      drinks: [],
	      desserts: [],
	      loading: true
	    };
	    return _this;
	  }
	
	  MenuPage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _getSheetDone2.default.labeledCols("1y9YVhJJCYs7NBj2a-aql7JJPFI6mmXW06efDaXBGYkc", 1).then(function (sheet) {
	      console.log(sheet);
	      _this2.setState({ entrees: sheet.data });
	    });
	    _getSheetDone2.default.labeledCols("1y9YVhJJCYs7NBj2a-aql7JJPFI6mmXW06efDaXBGYkc", 2).then(function (sheet) {
	      console.log(sheet);
	      _this2.setState({ drinks: sheet.data });
	    });
	    _getSheetDone2.default.labeledCols("1y9YVhJJCYs7NBj2a-aql7JJPFI6mmXW06efDaXBGYkc", 3).then(function (sheet) {
	      console.log(sheet);
	      _this2.setState({ desserts: sheet.data, loading: false });
	    });
	  };
	
	  MenuPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "main",
	      null,
	      _react2.default.createElement(_nav2.default, null),
	      _react2.default.createElement(_breadcrumb2.default, { title: "Menu" }),
	      !this.state.loading ? _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          {
	            className: "col-12 text-center menu-footer",
	            style: { margin: "20 0" }
	          },
	          "All menu items are pulled in from a Google Sheet automatically that you can see",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              target: "_blank",
	              href: "https://docs.google.com/spreadsheets/d/1y9YVhJJCYs7NBj2a-aql7JJPFI6mmXW06efDaXBGYkc/edit?usp=sharing"
	            },
	            "here"
	          )
	        ),
	        _react2.default.createElement(_menuItems2.default, {
	          data: this.state.entrees,
	          title: "Entrees",
	          description: "All entrees come with a side of our artisanal sourdough bread"
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 text-center menu-footer" },
	          "Vegetarian items marked with a ",
	          _react2.default.createElement(_fa.FaCutlery, null)
	        ),
	        _react2.default.createElement(_menuItems2.default, { data: this.state.drinks, title: "Drinks" }),
	        _react2.default.createElement(_menuItems2.default, { data: this.state.desserts, title: "Desserts" })
	      ) : _react2.default.createElement(
	        "div",
	        { className: "loading" },
	        _react2.default.createElement(_reactSpinkit2.default, { fadeIn: "none", name: "ball-scale-ripple" })
	      ),
	      _react2.default.createElement("div", { style: { height: 70 } })
	    );
	  };
	
	  return MenuPage;
	}(_react2.default.Component);
	
	exports.default = MenuPage;
	
	// used with the first commented out line of Menu Items
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-menu-js-fafacf175b811ed42779.js